import React, { ReactNode } from "react";
import { Link } from "react-router-dom";
import { PrimaryButtons } from "./buttons";
import HandPhone from "../../assets/img/Hands - Phone 1.png";

interface ErrorPageProps {
  title: string;
  children?: ReactNode;
  showHomeButton?: boolean;
  showRefreshButton?: boolean;
  onRefresh?: () => void;
}

const ErrorPage: React.FC<ErrorPageProps> = ({
  title,
  children,
  showHomeButton = true,
  showRefreshButton = false,
  onRefresh,
}) => {
  const handleRefresh = () => {
    if (onRefresh) {
      onRefresh();
    } else {
      window.location.reload();
    }
  };

  return (
    <div className="h-[90vh] w-full flex flex-col justify-center items-center gap-2 px-4">
      <img src={HandPhone} alt="" />
      <h1 className="leading-[57px] font-[600] text-[48px] text-gray-500 mb-[14px] text-center">
        {title}
      </h1>
      <div className="leading-[24px] font-[400] text-[20px] text-gray-500 max-w-[400px] text-center">
        {children}
      </div>
      <div className="flex gap-3 mt-3">
        {showHomeButton && (
          <Link to="/">
            <PrimaryButtons label="Go Home" />
          </Link>
        )}
        {showRefreshButton && (
          <button
            onClick={handleRefresh}
            className="px-4 py-2 border border-gray-300 rounded-lg text-gray-700 hover:bg-gray-50"
          >
            Refresh Page
          </button>
        )}
      </div>
    </div>
  );
};

export default ErrorPage;
